import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds,    FirstAds , MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "حاسبة متوسط الجلوكوز المقدر";
const DESCRIPTION =
  "حاسبة متوسط الجلوكوز التقديري (eAG): احسب مستويات السكر في الدم لمدة 3 أشهر بناءً على تحليل الهيموغلوبين السكري (HbA1c)! أداة معتمدة طبياً لمرضى السكري مع تفسير النتائج ومقارنتها بالمستويات الموصى بها.";
const KEYWORDS = "حاسبة, متوسط الجلوكوز, HbA1c, سكر الدم";
const OG_URL =
  "https://do-calculate.com/calculator/ar/estimated-average-glucose-calculator/";
const diabetesRanges = {
  diabetes: {
    HbA1c: [
      {
        limit: 6,
        message: "✅ مستوى HbA1c الخاص بك أقل من هدف مرض السكري - عمل جيد!",
        bg: "alert alert-success",
      },
      { limit: 7, message: "✅ نسبة HbA1c جيدة", bg: "alert alert-success" },
      {
        limit: 7.5,
        message: "❗نسبة HbA1c مرتفعة جداً بشكل عام.",
        bg: "alert alert-danger",
      },
      {
        limit: 8,
        message: "❗نسبة HbA1c مرتفعة جداً بشكل عام.",
        bg: "alert alert-danger",
      },
      {
        limit: Infinity,
        message: "❗نسبة HbA1c مرتفعة جداً بشكل عام.",
        bg: "alert alert-danger",
      },
    ],
    eAG: [
      {
        limit: 140,
        message: "متوسط الجلوكوز التقديري ضمن النطاق الطبيعي.",
        bg: "alert alert-success",
      },
      {
        limit: 154.2,
        message: "متوسط الجلوكوز التقديري جيد.",
        bg: "alert alert-success",
      },
      {
        limit: Infinity,
        message: "مستوى الجلوكوز مرتفع.",
        bg: "alert alert-danger",
      },
    ],
  },
  nonDiabetes: {
    HbA1c: [
      {
        limit: 6,
        message: "💚 HbA1c الخاص بك ضمن النطاق الطبيعي.",
        bg: "alert alert-success",
      },
      {
        limit: 6.5,
        message:
          "🔶 مستوى HbA1c في مرحلة ما قبل السكري تواصل مع طبيب، تغذى جيدا وقم بالتمارين الرياضية.",
        bg: "alert alert-warning",
      },
      {
        limit: Infinity,
        message: "🔺 نتيجتك تدل على مرض السكري. استشر طبيبك.",
        bg: "alert alert-danger",
      },
    ],
    eAG: [
      {
        limit: 116,
        message: "مستوى الجلوكوز طبيعي.",
        bg: "alert alert-success",
      },
      {
        limit: Infinity,
        message: "مستوى الجلوكوز يشير إلى السكري! تواصل مع الطبيب.",
        bg: "alert alert-danger",
      },
    ],
  },
};
function EstimatedAverageGlucoseCalculator() {
  const [hbA1c, setHbA1c] = useState("");
  const [avgGlucose, setAvgGlucose] = useState("");
  const [diabetesStatus, setDiabetesStatus] = useState("no");
  const [feedback, setFeedback] = useState("");
  const handleHbA1cChange = (e) => {
    setHbA1c(e.target.value);
    setAvgGlucose("");
  };
  const handleAvgGlucoseChange = (e) => {
    setAvgGlucose(e.target.value);
    setHbA1c("");
  };
  const calculateResults = () => {
    if (hbA1c) {
      const hbA1cValue = parseFloat(hbA1c);
      const calculatedEAG = 28.7 * hbA1cValue - 46.7;
      setAvgGlucose(calculatedEAG.toFixed(2));
      provideFeedback(hbA1cValue, "HbA1c");
    } else if (avgGlucose) {
      const avgGlucoseValue = parseFloat(avgGlucose);
      const calculatedHbA1c = (avgGlucoseValue + 46.7) / 28.7;
      setHbA1c(calculatedHbA1c.toFixed(2));
      provideFeedback(avgGlucoseValue, "eAG");
    }
  };
  const provideFeedback = (value, type) => {
    let rangeType = diabetesStatus === "yes" ? "diabetes" : "nonDiabetes";
    let feedbackMessages = diabetesRanges[rangeType][type];
    for (let i = 0; i < feedbackMessages.length; i++) {
      if (value < feedbackMessages[i].limit) {
        setFeedback(feedbackMessages[i]);
        break;
      }
    }
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  متوسط الجلوكوز التقديري (eAG) وماذا يعني؟ متوسط الجلوكوز
                  التقديري (Estimated Average Glucose) هو مقياس يستخدم لتقدير
                  متوسط مستوى الجلوكوز في الدم على مدى فترة طويلة. يتم حسابه
                  باستخدام نسبة HbA1c (الهيموجلوبين A1c)، وهي عبارة عن مؤشر يعكس
                  متوسط ​​مستوى الجلوكوز في الدم على مدى 2-3 أشهر.
                </p>
                <p>
                  كيف يتم حساب متوسط الجلوكوز التقديري؟ نستخدم المعادلة التالية
                  لحساب متوسط الجلوكوز التقديري:{" "}
                  <p>متوسط الجلوكوز التقديري = (28.7 × HbA1c) - 46.7</p>
                  حيث:
                </p>
                <ul>
                  <li>
                    HbA1c هو نسبة مئوية تعكس متوسط ​​مستوى الجلوكوز في الدم على
                    مدى الأشهر السابقة.
                  </li>
                  <li>
                    القيمة 28.7 تمثل التحويل من وحدة HbA1c إلى متوسط ​​الجلوكوز
                    بوحدة مليغرام/ديسيلتر (mg/dL).
                  </li>
                  <li>
                    القيمة 46.7 تعوض للتحويل بين الوحدات وتعكس القيمة المتوقعة
                    لمتوسط ​​الجلوكوز في الدم عند HbA1c = 0%.
                  </li>
                </ul>
                <p>لماذا يهم متوسط الجلوكوز التقديري؟</p>
                <p>
                  متوسط الجلوكوز التقديري يساعد في تقدير مدى تحكم الشخص في
                  مستويات الجلوكوز في الدم على المدى الطويل. يعتبر مؤشرًا مهمًا
                  لإدارة مرض السكري، حيث يمكن للأشخاص المصابين بالسكري أو الذين
                  يعانون من مشاكل في تنظيم مستويات الجلوكوز استخدامه لتقييم
                  فعالية العلاج واتخاذ القرارات المناسبة.{" "}
                </p>
                <p>
                  تم تطوير الحاسبة بالاعتماد على{" "}
                  <a
                    href="https://www.ncbi.nlm.nih.gov/pmc/articles/PMC2742903/"
                    rel="nofollow"
                  >
                    مجموعة دراسة متوسط ​​الجلوكوز المشتق من A1c ترجمة اختبار A1C
                    إلى قيم الجلوكوز المتوسطة المقدرة.; رعاية مرضى السكري؛ يونيو
                    2008
                  </a>
                </p>
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds/>
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div className="bg-warning text-black text-center p-2">
                  <p>
                    يرجى إدخال حقل واحد فقط من الحقول التالية: نسبة HbA1c أو
                    متوسط الجلوكوز
                  </p>
                </div>
                <div dir="rtl">
                  <div>
                    <hr />
                                        <div className="form-group">
                      <label htmlFor="status" className="form-label ms-2">
                        هل تعاني من مرض السكري؟
                      </label>
                      <select
                        id="status"
                        value={diabetesStatus}
                        onChange={(e) => setDiabetesStatus(e.target.value)}
                        className="form-control"
                        style={{ width: "75%" }}
                      >
                        <option value="no">لا</option>
                        <option value="yes">نعم</option>
                      </select>
                    </div>
                    <hr />
                                        <div className="form-group">
                      <label htmlFor="hbA1c">أدخل نسبة HbA1c:</label>
                      <div
                        className="d-flex"
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <input
                          id="hbA1c"
                          type="number"
                          value={hbA1c}
                          onChange={handleHbA1cChange}
                          className="form-control"
                        />
                        <span className="input-group-text ">%</span>
                      </div>
                    </div>
                    <hr />
                                        <div className="form-group">
                      <label htmlFor="avgGlucose">أدخل متوسط الجلوكوز:</label>
                      <div
                        className="d-flex"
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <input
                          id="avgGlucose"
                          type="number"
                          value={avgGlucose}
                          onChange={handleAvgGlucoseChange}
                          className="form-control"
                        />
                        <span className="input-group-text ">(mg/dL)</span>
                      </div>
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px", marginLeft: "10px" }}
                      onClick={calculateResults}
                    >
                      احسب                    </button>
                    <hr />
                                        { feedback && (
                      <div
                        className={`p-3 mb-2 ${feedback.bg}`}
                        style={
                          feedback.bg === "alert alert-danger"
                            ? { backgroundColor: "#DC3545" }
                            : {}
                        }
                      >
                        <h4>النتيجة:</h4>
                        <p>{feedback.message}</p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <hr />            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                جدول التحويل بين HbA1c ومتوسط الجلوكوز
              </div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>جدول التحويل</h2>
                  </u>
                  <p>
                    يتيح لك هذا الجدول تحويل HbA1c إلى متوسط الجلوكوز بدون
                    الحاجة إلى حسابات.
                  </p>
                  <table className="bmi-table" style={{ overflowX: "auto" }}>
                    <thead>
                      <tr>
                        <th >HbA1c</th>
                        <th ></th>
                        <th >eAG</th>
                        <th ></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>%</td>
                        <td>mmol/mol</td>
                        <td>mmol/L</td>
                        <td>mg/dl</td>
                      </tr>
                      <tr>
                        <td>5</td>
                        <td>31</td>
                        <td>(4.2–6.7) 5.4</td>
                        <td>97 (76–120)</td>
                      </tr>
                      <tr>
                        <td>6</td>
                        <td>42</td>
                        <td>(5.5–8.5) 7.0</td>
                        <td>126 (100–152)</td>
                      </tr>
                      <tr>
                        <td>7</td>
                        <td>53</td>
                        <td>(6.8–10.3) 8.6</td>
                        <td>154 (123–185)</td>
                      </tr>
                      <tr>
                        <td>8</td>
                        <td>64</td>
                        <td>(8.1–12.1) 10.2</td>
                        <td>183 (147–217)</td>
                      </tr>
                      <tr>
                        <td>9</td>
                        <td>75</td>
                        <td>(9.4–13.9) 11.8</td>
                        <td>212 (170–249)</td>
                      </tr>
                      <tr>
                        <td>10</td>
                        <td>86</td>
                        <td>(10.7–15.7) 13.4</td>
                        <td>240 (193–282)</td>
                      </tr>
                      <tr>
                        <td>11</td>
                        <td>97</td>
                        <td>(12.0–17.5) 14.9</td>
                        <td>269 (217–314)</td>
                      </tr>
                      <tr>
                        <td>12</td>
                        <td>108</td>
                        <td>(13.3–19.3) 16.5</td>
                        <td>298 (240–347)</td>
                      </tr>
                      <tr>
                        <td>13</td>
                        <td>119</td>
                        <td>(15–21) 18.1</td>
                        <td>326 (260–380)</td>
                      </tr>
                      <tr>
                        <td>14</td>
                        <td>130</td>
                        <td>(16–23) 19.7</td>
                        <td>355 (290–410)</td>
                      </tr>
                      <tr>
                        <td>15</td>
                        <td>140</td>
                        <td>(17.5–25) 21.3</td>
                        <td>384 (310–440)</td>
                      </tr>
                      <tr>
                        <td>16</td>
                        <td>151</td>
                        <td>(19–26) 22.9</td>
                        <td>413 (330–480)</td>
                      </tr>
                      <tr>
                        <td>17</td>
                        <td>162</td>
                        <td>(20–28) 24.5</td>
                        <td>441 (460–510)</td>
                      </tr>
                      <tr>
                        <td>18</td>
                        <td>173</td>
                        <td>(21–30) 26.1</td>
                        <td>470 (380–540)</td>
                      </tr>
                      <tr>
                        <td>19</td>
                        <td>184</td>
                        <td>(23–32) 27.7</td>
                        <td>499 (410–570)</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <hr />
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default EstimatedAverageGlucoseCalculator;
